import React from 'react';
import {PowerList} from '../';
import {Search} from '../../assets/icons/icons';
import {IpowerBlank, IpowerContainer, IpowerPlaceholder, IpowerBadge, IpowerIcon, IpowerSpan} from './styles';

export default ({
  dataArray = [],
  onClick,
  handleCancel,
  search = true,
  selectedTeams,
  mHeigth = '200px',
  mWidth = '150px',
  maxWidth = '800px',
  placeholder = 'Choose your team (optional)',
}: {
  onClick: any;
  search?: boolean;
  mHeigth?: string;
  mWidth?: string;
  maxWidth?: string;
  handleCancel: any;
  placeholder?: string;
  dataArray?: Array<any>;
  selectedTeams?: Array<any>;
}) => (
  <IpowerContainer mWidth={mWidth}>
    <IpowerBlank maxWidth={maxWidth}>
      {Boolean(selectedTeams?.length) ? (
        <>
          {selectedTeams?.map((el, idx) => (
            <IpowerBadge key={idx} style={{margin: '0 4px'}}>
              <IpowerSpan>{el?.name || ''}</IpowerSpan>
              <IpowerIcon onClick={() => handleCancel(el)} />
            </IpowerBadge>
          ))}
        </>
      ) : (
        <>
          {search ? <Search /> : <></>}
          <IpowerPlaceholder>{placeholder}</IpowerPlaceholder>
        </>
      )}
    </IpowerBlank>
    {Boolean(dataArray.length) ? <PowerList data={dataArray} search={search} onClick={onClick} mHeigth={mHeigth} /> : <></>}
  </IpowerContainer>
);
